import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './AvailabilityStatus.scss';

export default function AvailabilityStatus({ status, rollUpStatus, availabilityLocationType, ...props }) {
  return (
    <FormattedMessage
      id={`circ_${status ? status.toLowerCase() : rollUpStatus.toLowerCase()}`}
      values={{ location: availabilityLocationType }}
    >
      {statusMessage => (
        <span
          {...props}
          className={`cp-availability-status ${rollUpStatus.toLowerCase()}`}
          data-key={`availability-status-${rollUpStatus.toLowerCase()}`}
        >
          {statusMessage}
        </span>
      )}
    </FormattedMessage>
  );
}

AvailabilityStatus.propTypes = {
  status: PropTypes.string.isRequired,
  rollUpStatus: PropTypes.string.isRequired,
  availabilityLocationType: PropTypes.string.isRequired
};
